import { ReactNode } from "react";
import receipt from "../../../assets/receipt.png";
import { bookingInProgressIcon, confirmLogo as confimLogo } from "../../../constant";
import { Messages } from "../../../constant/messages/toastMessages";
import BrandCheckCircleIcon from "../../../assets/reactSVGIcon/BrandCheckCircleIcon";
import { fw } from "../../../styles/design-tokens";
import AppButton from "../button/button";
import BrandedRasterIcon from "../brandedRasterIcon/BrandedRasterIcon";
import Typography from "../typography/Typography";
import styles from "../../../routes/payment-success/stripeSuccess.module.scss";

interface Props {
  className: string;
  inProgress: boolean;
  itineraryId: string;
  email?: string;
  notes?: ReactNode;
  onGoToTrip: () => void;
  onPlanNewTrip?: () => void;
}

export default function BookingConfirmation({
  className,
  inProgress,
  itineraryId,
  email,
  notes,
  onGoToTrip,
  onPlanNewTrip,
}: Readonly<Props>) {
  const status = Messages[inProgress ? "booking.confirmation.inprogress" : "booking.confirmation.booked"];
  const card = Messages[inProgress ? "booking.confirmation.card.inprogress" : "booking.confirmation.card.booked"];
  return (
    <div className={className}>
      <BrandedRasterIcon src={confimLogo} alt="booked" className={styles.illustration} width={65} height={76} />

      <div className={styles.header}>
        {inProgress ? (
          <img src={bookingInProgressIcon} alt="Booking in progress" className={styles.checkIcon} />
        ) : (
          <BrandCheckCircleIcon alt="Booked" className={styles.checkIcon} />
        )}
        <Typography size="size16" weight={600}>
          {status.messageTitle}
        </Typography>
      </div>

      <div className={styles.description}>
        <Typography size="size14">
          {status.message}

          {!inProgress && (
            <Typography variant="span" size="size14" className={styles.subText}>
              {Messages["booking.confirmation.email"].message}{" "}
            </Typography>
          )}
          <div>
            <Typography variant="span" size="size14" weight={600} className={styles.email}>
              {email}
            </Typography>
          </div>
        </Typography>
      </div>

      <Typography size="size14" className={styles.subText}>
        {Messages["booking.confirmation.mytrips"].message}{" "}
        {inProgress && Messages["booking.confirmation.happy.travels"].message}
      </Typography>

      <div className={styles.confirmationCard}>
        <div className={styles.cardHeader}>
          <img src={receipt} alt="receipt" />
          <Typography weight={600}>{card.messageTitle}</Typography>
        </div>

        <Typography size="size12" className={styles.confirmationText}>
          {card.message}&nbsp;
          <span style={{ fontWeight: fw(600) }}>{itineraryId}</span>
        </Typography>

        {notes}

        <div className={styles.actions}>
          {onPlanNewTrip ? (
            <AppButton className={styles.secondaryButton} variant="secondary" onClick={() => onPlanNewTrip()}>
              {Messages["booking.confirmation.plan.new.trip"].message}
            </AppButton>
          ) : null}
          <AppButton className={styles.primaryButton} onClick={() => onGoToTrip()}>
            {Messages["booking.confirmation.go.to.trip"].message}
          </AppButton>
        </div>
      </div>
    </div>
  );
}
